import React from 'react';
import { UserFromCache } from '../types';

const Context = React.createContext<UserFromCache>({
  firstName: '',
  lastName: '',
  email: '',
  secret: '',
});

export const UserFromCacheProvider = Context.Provider;

export function useUserFromCache(): UserFromCache {
  return React.useContext(Context);
}
